import { createRESTStore } from "@stores/shared/createRESTStore";
import apiClient from "@services/api/apiClient";
import API from "@config/shared/api-paths";

const initialConfig = {
  page: 1,
  pageSize: 100,
  query: "",
  semanticWeight: 1,
};

const useSearchStore = createRESTStore({
  entityName: "searchData",
  apiPaths: {
    fetch: API.BASE + API.SEARCH,
  },
  initialState: null,
  additionalActions: (set, get) => ({
    config: { ...initialConfig },
    searchData: null,
    searchRolodex: null,
    searchError: null,
    hasMore: false,

    fetchSearchData: async () => {
      set({ fetching: true, searchError: null });
      try {
        const { query, page, pageSize, semanticWeight } = get().config;
        const result = await apiClient.get(
          `${get().apiPaths.fetch}?query=${query}&semanticWeight=${semanticWeight}&page=${page}&pageSize=${pageSize}`,
        );
        const items = result.data.items.map(({ document, highlights }) => ({
          ...document,
          highlights,
        }));
        const { totalCount, page: pg, pageSize: ps } = result.data;
        set({
          searchData: items,
          searchRolodex: { totalCount, page: pg, pageSize: ps },
          hasMore: pg * ps < totalCount,
          fetching: false,
        });
      } catch (error) {
        set({
          searchData: null,
          searchRolodex: null,
          searchError: error,
          hasMore: false,
          fetching: false,
        });
        console.log(error);
      }
    },

    loadMore: async () => {
      if (get().fetching || !get().hasMore) return;
      const nextPage = get().config.page + 1;
      set((state) => ({
        config: { ...state.config, page: nextPage },
        fetching: true,
      }));
      try {
        const { query, pageSize, semanticWeight } = get().config;
        const result = await apiClient.get(
          `${get().apiPaths.fetch}?query=${query}&semanticWeight=${semanticWeight}&page=${nextPage}&pageSize=${pageSize}`,
        );
        const newItems = result.data.items.map(({ document, highlights }) => ({
          ...document,
          highlights,
        }));
        const { totalCount, page: pg, pageSize: ps } = result.data;
        set((state) => ({
          searchData: [...(state.searchData ?? []), ...newItems],
          searchRolodex: { totalCount, page: pg, pageSize: ps },
          hasMore: pg * ps < totalCount,
          fetching: false,
        }));
      } catch (error) {
        set({ fetching: false });
        console.log(error);
      }
    },

    setSearchQuery: async (query) => {
      set((state) => ({
        config: { ...state.config, query, page: 1 },
      }));
      await get().fetchSearchData();
    },

    setSemanticWeight: (semanticWeight) => {
      set((state) => ({ config: { ...state.config, semanticWeight } }));
    },
  }),
});

export default useSearchStore;
